"use strict";

Shopify.theme.jsCollection = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsCollection = $.extend(this, Shopify.theme.getSectionData($section)); //Ensure product media libraries are present

    window.Shopify.loadFeatures([{
      name: 'model-viewer',
      version: '0.8'
    }, {
      name: 'shopify-xr',
      version: '1.0'
    }, {
      name: 'model-viewer-ui',
      version: '1.0'
    }]);

    // Collection Denim
    var $denimSlider = $('.collection__denim-slider');

    if ($denimSlider) {
      const $observer = new MutationObserver((mutations, obs) => {
        mutations.forEach((mutation) => {
          const $sliderItemImage = document.querySelector('.collection__denim-slider .collection__denim-slider-item .collection__denim-slider-item-image')

          if ($sliderItemImage && window.isDenimSliderLoaded) {
            Shopify.theme.jsCollection.denimSliderController()
            window.isDenimSliderLoaded = false

            obs.disconnect()
            return
          }
        })
      })

      $observer.observe(document, {
        childList: true,
        subtree: true
      })
    }

    // Product Card
    var $productCard = $('.product__grid-item');
    if ($productCard) {
      Shopify.theme.jsCollection.hoverProductCard($productCard);
    }

    if (this.enable_sorting == true) {
      $('#sort-by').val($('#sort-by').data('default-sort'));
    }

    if (this.enable_filter == true || this.enable_sorting == true) {
      $('#tag_filter, #sort-by').on('change', function () {
        Shopify.theme.jsCollection.filterURL();
      });
    }

    if ($('[data-option-filter]').length) {
      // Show enabled filter tags based on selected checkboxes
      $('[data-tag-filter-checkbox]:checked').each(function () {
        Shopify.theme.jsCollection.multiTagFilter.showSelectedFilter($(this));
      });
    } // If breadcrumbs enabled and basic pagination is set, call breadcrumbs object


    if (this.enable_breadcrumb && this.pagination_type == 'basic_pagination') {
      Shopify.theme.breadcrumbs.init(this.number_of_pages);
    }
    /* Collection sidebar filter */


    $('body').on('click', '[data-option-filter]', function (e) {
      e.preventDefault();
      $(this).find('input').prop('checked', true);
      Shopify.theme.jsCollection.multiTagFilter.init($(this));
      Shopify.theme.scrollToTop($('.collection__content'));
    });
    $('body').on('click', '[data-clear-filter]', function () {
      var $el = $(this).siblings('[data-option-filter]');
      var $productTagFilter = $('#tag_filter');
      $productTagFilter.find('option:eq(0)').prop('selected', true);
      Shopify.theme.jsCollection.multiTagFilter.clearSelectedFilter($el);
      Shopify.theme.scrollToTop($('.collection__content'));
    });

    // call collection primary-secondary image observer
    Shopify.theme.jsCollection.observePrimarySecondaryImage()

    const gridItemsSelector = '.boost-pfs-filter-products .product__grid-item'
    let initialItemsCount = $(gridItemsSelector).length
    $(document).on('click', '#collection-pagination-conclusionBtn, .js-boost-pfs-filter-btn-load-previous-page', function() {
      const paginatedItemsInterval = setInterval(() => {
        const newItemsLength = $(gridItemsSelector).length
        if (newItemsLength > initialItemsCount) {
          clearInterval(paginatedItemsInterval)
          initialItemsCount = newItemsLength

          // call collection primary-secondary image observer
          Shopify.theme.jsCollection.observePrimarySecondaryImage('Pagination')
        }
      }, 1000);
    })
  },

  denimSliderController: function denimSliderController() {
    const $observer = new MutationObserver((mutations, obs) => {
      mutations.forEach((mutation) => {
        const $collectionDenimSlider = $('.collection__denim-slider')

        $collectionDenimSlider.removeClass('invisible')
        $collectionDenimSlider.css('opacity', 0)

        const $denimSliderMain = $('#shopify-section-collection__denim-slider')
        const $denimSliderItemHeight = $denimSliderMain.find('.collection__denim-slider-item').first().height()

        if ($denimSliderItemHeight > 100) {
          $denimSliderMain.flickity({
            freeScroll: true,
            contain: true,
            groupCells: true,
            pageDots: false,
            arrowShape: 'M20.6782 4.88889L15.7943 9.77778L15.0793 9.06282L18.7548 5.39238L0 5.39238L0 4.3854L18.7548 4.3854L15.0793 0.714956L15.7943 0L20.6782 4.88889Z'
          })

          $collectionDenimSlider.find('.flickity-viewport').css({"height":`${$denimSliderItemHeight}px`});

          // hover effect
          const $productCard = $('.collection__denim-slider-item');
          $productCard.on('mouseenter',(e)=>{
            const $currentTarget = $(e.currentTarget);
            $productCard.addClass('unhovering');
            $currentTarget.removeClass('unhovering').addClass('hovering');
          })

          $productCard.on('mouseleave',(e)=>{
            const $currentTarget = $(e.currentTarget);
            $productCard.removeClass('unhovering');
            $currentTarget.removeClass('hovering');
          })

          // open fit guide
          const $popUp = $('.collection__fit-guide');
          const $infoIcon = $('.collection__denim-slider-item-info');
          $infoIcon.on('click', (e)=>{
            e.stopPropagation();
            e.preventDefault();
            const $currentTarget = $(e.currentTarget);
            const collectionName = $currentTarget.attr('data-title');
            const $popUpItem = $(`.fit-guide-wrapper[data-title="${collectionName}"]`);
            $popUp.removeClass('invisible');
            $popUpItem.removeClass('invisible');
          })

          //close fit guide
          const $closeIcon = $popUp.find('.popup-close');
          $closeIcon.on('click', (e)=>{
            const $currentTarget = $(e.currentTarget);
            $currentTarget.parent().parent().parent().addClass('invisible');
            $popUp.addClass('invisible');
          })

          $collectionDenimSlider.css('opacity', 1)

          obs.disconnect()
          return
        }
      })
    });

    $observer.observe(document, {
      childList: true,
      subtree: true
    })

  },

  filterURL: function filterURL() {
    var selectedOptions = [],
        query = '',
        currentTags = '',
        siteUrl = 'https://' + $.url('hostname'),
        url1 = $.url('1') ? '/' + $.url('1') + '/' : '',
        url2 = $.url('2') ? $.url('2') + '/' : '',
        url3 = $.url('3'),
        path = url1 + url2; //Handle dropdowns if they exist

    if ($('#sort-by').length) {
      query = $('#sort-by').val();
    } else {
      query = url('?sort_by');
    }

    if ($('#tag_filter').length) {
      if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()) {
        var urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);

        if (urlTag != 'all') {
          if ($.inArray(urlTag, selectedOptions) > -1) {//Do nothing
          } else {
            selectedOptions.unshift(urlTag);
          }
        }
      }
    } //Add all checkbox values to array


    $('[data-option-filter] input:checked').each(function () {
      selectedOptions.push($(this).val());
    });
    selectedOptions = $.makeArray(selectedOptions); //Loop through tags to create string to update page url

    $.each(selectedOptions, function (i, value) {
      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + '+';
      } else {
        currentTags += selectedOptions[i];
      }
    });
    Shopify.theme.queryParameters.sort_by = query;
    query = '?' + $.param(Shopify.theme.queryParameters);
    this.processUrl(path, currentTags, query);
  },
  processUrl: function processUrl(path, tags, query) {
    var query = query.replace(/\page=(\w+)&/, ''),
        urlString = '';
    urlString = path + tags + query;
    this.updateView(urlString);
  },
  updateView: function updateView(filterURL) {
    $.ajax({
      type: 'GET',
      url: filterURL,
      beforeSend: function beforeSend() {
        $('.collection-matrix').addClass('fadeOut animated loading-in-progress');
        $('.collection-matrix__wrapper .collection__loading-icon').fadeIn();
      },
      success: function success(data) {},
      error: function error(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);
      },
      dataType: "html"
    }).then(function (data) {
      var $breadcrumbContainer = $('.breadcrumb__container');
      var $collectionMatrix = $('.collection-matrix');
      var $collectionMain = $('.collection__main'); // Get and set new breadcrumb html

      var filteredBreadcrumb = $(data).find('.breadcrumb__container').html();
      $breadcrumbContainer.html(filteredBreadcrumb); // Remove loading animation

      $collectionMatrix.removeClass('fadeIn animated loading-in-progress'); // Check for products

      var filteredData = $(data).find('.collection-matrix__wrapper');
      var filteredPageLinks = $(data).find('.container--pagination');
      var noProducts = $(data).find('.container--no-products-in-collection');

      if (filteredData.length) {
        // Add products to container
        $collectionMain.empty();
        $collectionMain.append(filteredData);
      } else {
        // Display no product message
        $collectionMain.empty();
        $collectionMain.append(noProducts);
      }

      $collectionMain.append(filteredPageLinks);
      window.history && window.history.pushState && window.history.pushState("", "", filterURL);

      if (Shopify.theme_settings.enable_shopify_collection_badges == true) {
        Shopify.theme.productReviews();
      }

      if (Shopify.theme_settings.show_multiple_currencies) {
        convertCurrencies();
      }
    });
  },
  multiTagFilter: {
    init: function init($el) {
      // Show filter and hide siblings
      this.showSelectedFilter($el); // Update url

      Shopify.theme.jsCollection.filterURL(); // Hide filters if types or vendors is in URL (can't be combined)

      if ($.url(2) === 'types' || $.url(2) === 'vendors') {
        $('.block__tag-filter').remove();
      }
    },
    showSelectedFilter: function showSelectedFilter($el) {
      var $sidebarToggleBlock = $el.parents('.sidebar-toggle-active');
      var $filterItem = $el.parents('.tag-filter__item');
      $filterItem.addClass('is-active');
      $filterItem.siblings(':not(.is-active)').addClass('is-hidden');
      $filterItem.find('[data-clear-filter]').removeClass('is-hidden'); // If sidebar toggle is enabled, show filter in sidebar content

      if ($sidebarToggleBlock.length) {
        var $toggleBtn = $sidebarToggleBlock.find('[data-sidebar-block__toggle="closed"]');
        Shopify.theme.jsSidebar.openSidebarBlock($toggleBtn);
      }
    },
    clearSelectedFilter: function clearSelectedFilter($el) {
      var $filterItem = $el.parents('.tag-filter__item');
      $filterItem.removeClass('is-active').find('input').prop("checked", false);
      $filterItem.siblings().removeClass('is-hidden');
      $filterItem.find('[data-clear-filter]').addClass('is-hidden'); //Update url

      Shopify.theme.jsCollection.filterURL();
    }
  },
  hoverProductCard: function hoverProductCard($productCard) {
    // product card init slider
    const $imageSlider = $productCard.find('.quick-shop__images-slider');
    if ( $(window).width() > 991 ) {
      $imageSlider.each(function() {
        $(this).find('a').first().remove();
      });
    }
    $imageSlider.flickity({
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'left',
      contain: true,
      freeScroll: false,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true,
      initialIndex: 0
    })

    $productCard.on('mouseenter touchstart',(e)=>{
      const $currentTarget = $(e.currentTarget);

      // product swatch init
      if (!$currentTarget.hasClass('product-swatch__initialized')) {
        const $instock = $currentTarget.find('.product-thumbnail__instock');
        $instock.map((i)=>{
          const option = $($instock[i]).html();
          $currentTarget.find(`.product-thumbnail__swatch-item[data-option="${option}"]`).removeClass('sold-out');
        })
      }

      const mr_sliders = $(e.currentTarget).find('.mr-lazy-slider')
      const $quickShop = $currentTarget.find('.quick-shop__info');
      const $wishList = $currentTarget.find('.swym-button');
      const $swatch = $currentTarget.find('.product-thumbnail__swatch');
      $quickShop.removeClass('product-card__hover');
      $wishList.removeClass('product-card__hover');
      $swatch.removeClass('product-card__hover');
      $currentTarget.addClass('product-swatch__initialized');
      mr_sliders.each(function(){
        const $slider = $(this);
        $slider.attr('srcset', $slider.data('srcset'));
        $slider.attr('src', $slider.data('src'));
      });
    })

    $productCard.on('mouseleave',(e)=>{
      const $currentTarget = $(e.currentTarget);

      const $quickShop = $currentTarget.find('.quick-shop__info');
      const $wishList = $currentTarget.find('.swym-button');
      const $swatch = $currentTarget.find('.product-thumbnail__swatch');
      $quickShop.addClass('product-card__hover');
      $wishList.addClass('product-card__hover');
      $swatch.addClass('product-card__hover');
    })
  },
  unload: function unload($section) {
    $('#tag_filter, #sort-by').off();
    $('[data-option-filter]').off();
    $('[data-reset-filters]').off();
    $('[data-clear-filter]').off();
    Shopify.theme.breadcrumbs.unload();
  },
  observePrimarySecondaryImage: function observePrimarySecondaryImage(type = 'Liquid') {
    // Create a new Intersection Observer instance
    const observer = new IntersectionObserver((entries, observer) => {
      console.log("Start Primary-Secondary Observer: "+type)
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const primaryImage = $(entry.target);
          const secondaryImages = primaryImage.parents('.image__container').find('.alt-secondary-image')

          // Check if a secondary image exists
          if (secondaryImages.length > 0) {
            secondaryImages.each(function() {
              const item = $(this)
              item.attr('src', item.attr('data-src'));
            })
          }

          // Stop observing the primary image after a certain time (optional)
          setTimeout(() => {
            observer.unobserve(primaryImage[0]);
          }, 5000); // Stop observing after 5 seconds (adjust as needed)
        }
      });
    });

    // Find all primary image elements with a specific class
    const $primaryImages = $(document.querySelectorAll('.image__container .alt-primary-image'));
    // Start observing each primary image element
    $primaryImages.each(function() {
      observer.observe(this);
    });
  }
};
